import React from 'react';
import './style/style.css'

export default function Loader(){
    return (
        <div className="loader"></div>
    )
}